import './displayTimeframe.html';

export default function() {
  return {
    replace: true,
    scope: {
      timeframes: '=',
    },
    templateUrl: 'directives/displayTimeframe/displayTimeframe.html',
    controller: Controller,
    controllerAs: 'vm',
    bindToController: true,
  };
}

Controller.$inject = ['$scope', '$ngRedux'];
function Controller($scope, $ngRedux) {
  const disconnect = $ngRedux.connect((state) => {
    return {
      router: state.router,
    };
  })(this);

  $scope.$on('$destroy', disconnect);

  // Initialize timeframe state
  const timeframeLength = this.timeframes ?
    this.timeframes.length - 1 :
    1;
  this.currentTimeframe = this.router.currentParams.currentTimeframe || '0';
  this.startTimeframe = this.router.currentParams.startTimeframe ||
    timeframeLength.toString();

  $scope.$watch(
    () => this.router.currentParams.startTimeframe,
    (newval) => this.startTimeframe = newval
  );

  $scope.$watch(
    () => this.router.currentParams.currentTimeframe,
    (newval) => this.currentTimeframe = newval
  );

  // When switching to graph view, ensure that selections are ordered correctly
  $scope.$watch(
    () => this.router.currentParams.activeTab,
    (newval, oldval) => {
      if (newval === 'graph') {
        this.currentOnly = false;
        if (oldval && newval !== oldval) {
          this.startTimeframe = this.timeframes && this.timeframes.length - 1;
          if (this.startTimeframe === +this.currentTimeframe) {
            this.currentTimeframe--;
          }
        }
      } else {
        this.currentTimeframe = this.router.currentParams.currentTimeframe;
        this.currentOnly = true;
      }
    }
  );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/displayTimeframe/displayTimeframe.js
 **/